import { useTranslation } from 'react-i18next'

import { CopyIcon, DotsThreeCircleVerticalIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ButtonMenu, IconButton, Switch, Text } from '@reveni-io/reveni-ui'

import DisabledTriggerChip from './DisabledTriggerChip/DisabledTriggerChip'
import * as Styles from './styles'

const TemplateListItem = ({
  label,
  description,
  enabled,
  templateId,
  internalId,
  onEdit,
  onToggleTemplate,
  onDelete,
  onDuplicate,
  disabled,
  hasDisabledTriggers,
  index,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container backgroundColor={index % 2 ? theme.colors.background.primary : theme.colors.background.secondary}>
      <Styles.IdentifierContainer>
        <Text type="bodyMBold">#{internalId}</Text>
      </Styles.IdentifierContainer>
      <Styles.InfoContainer>
        <Styles.HeaderRow>
          <Styles.TitleGroup>
            <Switch
              checked={enabled}
              disabled={disabled}
              onChange={e => onToggleTemplate(templateId, e.target.checked)}
              label={<Text type="titleS">{t(label)}</Text>}
            />
            {hasDisabledTriggers && <DisabledTriggerChip />}
          </Styles.TitleGroup>
          <ButtonMenu
            menuItems={[
              {
                label: (
                  <Styles.MenuItemContainer>
                    <PencilSimpleIcon weight="light" />
                    {t('Editar')}
                  </Styles.MenuItemContainer>
                ),
                onClick: onEdit,
              },
              {
                label: (
                  <Styles.MenuItemContainer>
                    <CopyIcon weight="light" />
                    {t('Duplicar')}
                  </Styles.MenuItemContainer>
                ),
                onClick: onDuplicate,
              },
              {
                label: (
                  <Styles.MenuItemContainer>
                    <TrashIcon weight="light" />
                    {t('Eliminar')}
                  </Styles.MenuItemContainer>
                ),
                onClick: onDelete,
              },
            ]}
            renderButton={onClick => (
              <IconButton
                onClick={onClick}
                variant="text"
                icon={<DotsThreeCircleVerticalIcon data-testid="icon" size={24} weight="light" />}
              />
            )}
          />
        </Styles.HeaderRow>
        {description && (
          <Styles.DescriptionContainer>
            <Text type="bodyMRegular">{t(description)}</Text>
          </Styles.DescriptionContainer>
        )}
      </Styles.InfoContainer>
    </Styles.Container>
  )
}

export default TemplateListItem
